import type { AnalysisStatus, SubmissionStatus } from '../types'

type Tone = 'accent' | 'dark' | 'danger' | 'muted' | 'success' | 'warning'

const statusTone: Record<SubmissionStatus | AnalysisStatus, Tone> = {
  approved: 'success',
  archived: 'muted',
  analysis_complete: 'success',
  analysis_failed: 'danger',
  analysis_pending: 'warning',
  draft: 'muted',
  rejected: 'danger',
  reopened: 'warning',
  returned: 'warning',
  submitted: 'accent'
}

const label = (value: string) => value.replace(/_/g, ' ')

export const Badge = ({ children, tone }: { children: React.ReactNode; tone?: Tone }) => (
  <span className={`badge badge-${tone || 'muted'}`}>{children}</span>
)

export const StatusBadge = ({ status }: { status: SubmissionStatus | AnalysisStatus }) => (
  <Badge tone={statusTone[status]}>{label(status)}</Badge>
)
